import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../../../../state/refresh'
import { useRequests } from '../../../../requests/useRequests'
import Modal from '../../../Modal/Modal'

interface ItemImageModalProps {
  show: boolean
  onClose: () => void
  onSave: () => void
  itemId: string
  projectId: string
  currentImageUrl?: string
}

const ItemImageModal: React.FC<ItemImageModalProps> = ({
  show,
  onClose,
  onSave,
  itemId,
  projectId,
  currentImageUrl
}) => {
  const dispatch = useDispatch()
  const requestMaker = useRequests()
  const [imageUploading, setImageUploading] = useState<boolean>(false)
  const [imagePreview, setImagePreview] = useState<string | null>(currentImageUrl || null)

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if ((e.target.files != null) && e.target.files[0]) {
      try {
        setImageUploading(true)

        // Wyślij plik do serwera
        const response = await requestMaker.uploadFile(e.target.files[0], 'project')

        // Aktualizuj podgląd
        setImagePreview(response.data.presignedUrl)

        // Aktualizuj zdjęcie elementu
        await requestMaker.updateProjectItem(projectId, itemId, {
          imageUrl: response.data.fileKey
        })

        dispatch(
          RefreshActions.setToastMessage({
            message: 'Zdjęcie zostało zaktualizowane'
          })
        )

        onSave()
      } catch (error) {
        console.error('Błąd podczas przesyłania zdjęcia:', error)
        dispatch(
          RefreshActions.setToastMessage({
            message: 'Nie udało się zaktualizować zdjęcia'
          })
        )
      } finally {
        setImageUploading(false)
      }
    }
  }

  const handleDeleteImage = async () => {
    try {
      setImageUploading(true)

      // Aktualizuj element projektu, usuwając URL zdjęcia
      await requestMaker.updateProjectItem(projectId, itemId, {
        imageUrl: null
      })

      setImagePreview(null)

      dispatch(
        RefreshActions.setToastMessage({
          message: 'Zdjęcie zostało usunięte'
        })
      )

      onSave()
    } catch (error) {
      console.error('Błąd podczas usuwania zdjęcia:', error)
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Nie udało się usunąć zdjęcia'
        })
      )
    } finally {
      setImageUploading(false)
    }
  }

  return (
    <Modal
      show={show}
      onClose={onClose}
      title='Edytuj zdjęcie'
      size='md'
    >
      <div className='modal-body' style={{ padding: '20px' }}>
        <div className='form-group'>
          <label className='form-label'>Zdjęcie</label>
          <div className='profile-image-upload'>
            <div
              className='profile-image-preview mb-20'
              style={{
                width: '100%',
                height: '300px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                overflow: 'hidden'
              }}
            >
              {imagePreview
                ? (
                  <img
                    src={imagePreview}
                    alt='Podgląd zdjęcia'
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain'
                    }}
                  />
                  )
                : (
                  <div className='text-center p-3'>
                    <i className='fa fa-image fa-3x text-muted mb-2' />
                    <p className='mb-0'>Brak zdjęcia</p>
                  </div>
                  )}
            </div>
            <div className='input-group'>
              <input
                type='file'
                id='itemImage'
                accept='image/*'
                className='form-control'
                onChange={handleImageChange}
                disabled={imageUploading}
                style={{ height: 'auto' }}
              />
              {imageUploading && (
                <div className='ms-2 d-flex align-items-center'>
                  <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true' />
                  <span className='ms-1'>Przesyłanie...</span>
                </div>
              )}
            </div>
            <small className='form-text text-muted mt-2'>
              Maksymalny rozmiar pliku: 2MB. Dozwolone formaty: JPG, PNG, GIF
            </small>
          </div>
        </div>
      </div>
      <div className='modal-footer' style={{ padding: '15px 20px' }}>
        {imagePreview && (
          <button
            type='button'
            className={`
              tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
              tw-text-white
              tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-red-500 hover:tw-bg-opacity-90 focus:tw-bg-red-500
            `}
            onClick={handleDeleteImage}
            disabled={imageUploading}
          >
            Usuń zdjęcie
          </button>
        )}
        <button
          type='button'
          className={`
                      tw-text-center tw-font-semibold tw-rounded-md tw-shadow-lg tw-transition-colors
                      tw-text-teal
                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-white hover:tw-bg-opacity-90 focus:tw-bg-white
                    `}
          onClick={onClose}
          disabled={imageUploading}
        >
          Zamknij
        </button>
      </div>
    </Modal>
  )
}

export default ItemImageModal
